import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { throwIfNotOk } from '../throwIfNotOk';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/project/upload-thumbnail', 'post'>;

type Params = {
  projectId: number;
  thumbnail: File;
};

type Result = number;

export const uploadThumbnailFactory = (apiClient: ApiClient) => {
  const uploadThumbnail = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/project/upload-thumbnail'].post(requestBody);

    await throwIfNotOk(response, 'upload the thumbnail');
    return mapResponseToResult(variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      formData: {
        formFile: input.thumbnail,
        projectId: input.projectId,
      },
    };
  };

  const mapResponseToResult = (input: Params): Result => {
    return input.projectId;
  };

  return uploadThumbnail;
};
